<template>
  <v-layout row wrap justify-center>
    <v-flex xs12 sm6 md3> 
      <!-- <label>{{ labelText }}</label> -->
      <v-text-field class="font-weight-medium" type="password" v-model="otpCode" :label="labelText" outline></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from "vue";
export default {
  props: {
    labelText: String
  },
  watch: {
    otpCode() {
      Vue.prototype.$otp = this.otpCode;
    }
  },
  data() {
    return {
      otpCode: ""
    };
  }
};
</script>

<style>
</style>
